import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["name", "disabled"];
const _hoisted_2 = ["selected"];
const _hoisted_3 = ["value"];
const _hoisted_4 = {
    key: 1,
    disabled: "",
    selected: "",
    value: "",
    "data-placeholder": "true"
};
import FormInput from "../../../../components/form/FormInput.vue";
import { computed, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryTime',
    props: /*@__PURE__*/ _mergeModels({
        mode: String,
        name: String,
        error: String,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, "modelValue");
        const timeSlots = computed(() => {
            if (props.mode === 'today') {
                return [
                    '14:00 - 19:00',
                    '17:00 - 22:00',
                ];
            }
            if (props.mode === 'regions') {
                return [
                    '10:00 - 16:00',
                    '13:00 - 18:00',
                ];
            }
            if (props.mode === 'workdays') {
                return [
                    '10:00 - 14:00',
                    '11:00 - 15:00',
                    '12:00 - 16:00',
                    '13:00 - 17:00',
                    '14:00 - 18:00',
                    '15:00 - 19:00',
                    '16:00 - 20:00',
                    '17:00 - 21:00',
                    '18:00 - 22:00',
                ];
            }
            if (props.mode === 'holidays') {
                return [
                    '10:00 - 14:00',
                    '12:00 - 16:00',
                    '14:00 - 18:00',
                ];
            }
            return [];
        });
        watch(timeSlots, () => value.value = '');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormInput, {
                name: "time",
                type: "select",
                label: "Временной интервал",
                error: __props.error,
                required: "",
                modelValue: value.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((value).value = $event))
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        name: __props.name,
                        disabled: !timeSlots.value.length,
                        required: "",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                    }, [
                        (timeSlots.value.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("option", {
                                    disabled: "",
                                    selected: !value.value,
                                    value: "",
                                    "data-placeholder": "true"
                                }, "Выберите интервал", 8 /* PROPS */, _hoisted_2),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSlots.value, (timeSlot) => {
                                    return (_openBlock(), _createElementBlock("option", { value: timeSlot }, _toDisplayString(timeSlot), 9 /* TEXT, PROPS */, _hoisted_3));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock("option", _hoisted_4, "Сначала укажите дату"))
                    ], 8 /* PROPS */, _hoisted_1), [
                        [_vModelSelect, value.value]
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["error", "modelValue"]));
        };
    }
});
